export function toCurrency(n) {
  return Number.parseFloat ?
    String(Number.parseFloat(n).toFixed(2)).replace('.', ',') :
    String(n);
}

export function getNotice(string) {
  if (typeof (string) === 'undefined') {
    string = '';
  }
  return {
    colSpan: 2,
    text: string ?
      string.replace(/&lt;[^&]*&gt;/g, '').replace(/&gt;[^&]*&lt;/g, '') : '',
    style: (string.match(/&lt;[^&]*&gt;/g) ||
      string.match(/&lt;[^&]*&gt;/g)) ? 'boldNotice' : 'notice'
  };
}

export function simpleDate(string) {
  return {
      year: string.substr(0, 4),
      month: string.substr(5, 2),
      day: string.substr(8, 2),
      monthYear: `${string.substr(5, 2)}.${string.substr(0, 4)}`,
      dayMonthYear: `${string.substr(8, 2)}.${string.substr(5, 2)}.${string.substr(0, 4)}`
  };
}



export function simpleDate_2(string) {
  return {
      year: string.substr(0, 4),
      month: string.substr(5, 2),
      day: string.substr(8, 2),
      monthYear: `${string.substr(5, 2)}.${string.substr(0, 4)}`,
      dayMonthYear: `${string.substr(8, 2)}.${string.substr(5, 2)}.${string.substr(0, 4)}`
  };
}

export function lastDay(string) {
  let start = simpleDate(string);
  let end = simpleDate(new Date(start.year, Number(start.month), 1).toISOString());
  return start.dayMonthYear + ' - ' + end.dayMonthYear;
}


export function lastDay_st(string) {
  let start = simpleDate(string);
  //let end = simpleDate(new Date(start.year, Number(start.month), 1).toISOString());
  return start.dayMonthYear;
}


export const get = {
  'point': (data, number) => {
      let point = data.bill.billPoint[number];
      return point.pointPeriod ? point.pointPeriod[0] : simpleDate(point.point[0]).monthYear;
  },
  'point2': (data, number) => {
  let point2;
    data.bill.pastPayPeriod ? point2=data.bill.pastPayPeriod[0] : point2="11.01.2019 - 10.04.2019";
    //let point2 = data.bill.pastPayPeriod[0];
    return point2 ? point2 : simpleDate(data.bill.pastPayPeriod[0]).dayMonthYear;
},
  'percent': (data) => {
      let percent = data.bill.periodPercent[0];
      return percent ? percent : simpleDate(data.bill.feePercentDate[0]).dayMonthYear;
  },
  'fee': (data) => {
      let fee = data.bill.periodFee[0];
      return fee ? fee : simpleDate(data.bill.feePercentDate[0]).dayMonthYear;
  },
  'duty': (data) => {
      let duty = data.bill.periodDuty[0];
      return duty ? duty : simpleDate(data.bill.dateFrom[0]).monthYear;
  },
  'qPayDateStart': (data) => {
    let qPayDateStart = data.bill.qPayDateStart[0];
    return qPayDateStart ? qPayDateStart : '-';
  },
  'periodDuty2025': (data) => {
    let periodDuty2;
      data.bill.periodDuty2 ? periodDuty2=data.bill.periodDuty2[0] : periodDuty2="11.01.2019 - 10.04.2019";
      return periodDuty2 ? periodDuty2 : simpleDate(data.bill.pastPayPeriod[0]).dayMonthYear;
  },
  'periodFee2025': (data) => {
    let periodFee2;
      data.bill.periodFee2 ? periodFee2=data.bill.periodFee2[0] : periodFee2="11.01.2019 - 10.04.2019";
      return periodFee2 ? periodFee2 : simpleDate(data.bill.pastPayPeriod[0]).dayMonthYear;
  },
  'duty2025': (data) => {
    let duty2 = data.bill.periodDuty2[0];
    return duty2 ? duty2 : simpleDate(data.bill.dateFrom[0]).monthYear;
  },
  'fee2025': (data) => {
    let fee2 = data.bill.periodFee2[0];
    return fee2 ? fee2 : simpleDate(data.bill.feePercentDate[0]).dayMonthYear;
  }
}





























// WEBPACK FOOTER //
// ./src/helpers.js